import * as i0 from '@angular/core';
import { input, computed, output, effect, Component, ViewEncapsulation } from '@angular/core';
import { NgClass, NgIf, NgStyle, NgTemplateOutlet, NgSwitch, NgSwitchCase } from '@angular/common';
import { ColorConverterService } from '@digipay/ng-lib-color-converter';
import * as i1 from '@digipay/ng-ui-api-image';
import { ApiImageModule } from '@digipay/ng-ui-api-image';
import * as i3 from '@digipay/ngx-spinner';
import { NgxSpinnerModule } from '@digipay/ngx-spinner';
import * as i4 from '@digipay/ngx-badge';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import * as i1$1 from '@digipay/ng-lib-pipes';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxIcon } from '@digipay/ngx-icon';
import { NgxSkeletonLoadingComponent } from '@digipay/ngx-skeleton-loading';
function BankCardComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.Icons.BACKGROUND_TEMPLATE, i0.ɵɵsanitizeUrl);
  }
}
function BankCardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ngx-badge", 2);
    i0.ɵɵtext(1, " \u062E\u0627\u0631\u062C \u0627\u0632 \u062F\u0633\u062A\u0631\u0633 ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("size", "sm")("status", "inactive");
  }
}
function BankCardComponent_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "p", 4);
    i0.ɵɵtext(2, ". . . . . . .");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 4);
    i0.ɵɵtext(4, ". . . . . . .");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 4);
    i0.ɵɵtext(6, ". . . . . . .");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p", 4);
    i0.ɵɵtext(8, ". . . . . . .");
    i0.ɵɵelementEnd()();
  }
}
function BankCardComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function BankCardComponent_Conditional_3_Conditional_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onNewClick());
    });
    i0.ɵɵelement(1, "img", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.Icons.NEW, i0.ɵɵsanitizeUrl);
  }
}
function BankCardComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BankCardComponent_Conditional_3_Conditional_0_Template, 9, 0, "div", 3)(1, BankCardComponent_Conditional_3_Conditional_1_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(0, ctx_r0.isTyping() ? 0 : 1);
  }
}
function BankCardComponent_Conditional_4_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.alias(), " ");
  }
}
function BankCardComponent_Conditional_4_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" \u0628\u0627\u0646\u06A9 ", (tmp_3_0 = ctx_r0.changeSignal()) == null ? null : tmp_3_0.name, " ");
  }
}
function BankCardComponent_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BankCardComponent_Conditional_4_Conditional_1_Conditional_0_Template, 2, 1, "p", 11)(1, BankCardComponent_Conditional_4_Conditional_1_Conditional_1_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(0, ctx_r0.alias() ? 0 : 1);
  }
}
function BankCardComponent_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1, " \u06A9\u0627\u0631\u062A \u062C\u062F\u06CC\u062F ");
    i0.ɵɵelementEnd();
  }
}
function BankCardComponent_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-api-image", 8);
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("imageId", (tmp_2_0 = ctx_r0.changeSignal()) == null ? null : tmp_2_0.cardBankLogoImageId)("width", ctx_r0.logoWidth() + "px")("height", ctx_r0.logoHeight() + "px");
  }
}
function BankCardComponent_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("width", ctx_r0.logoWidth())("height", ctx_r0.logoHeight())("src", ctx_r0.Icons.DEFUALT_CARD, i0.ɵɵsanitizeUrl);
  }
}
function BankCardComponent_Conditional_4_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r0.Icons.EMPTY, i0.ɵɵsanitizeUrl);
  }
}
function BankCardComponent_Conditional_4_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "cardNumber");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 1, ctx_r0.cardNumber(), " "), " ");
  }
}
function BankCardComponent_Conditional_4_Conditional_9_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-spinner", 13);
  }
}
function BankCardComponent_Conditional_4_Conditional_9_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.ownerName(), " ");
  }
}
function BankCardComponent_Conditional_4_Conditional_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BankCardComponent_Conditional_4_Conditional_9_Conditional_0_Conditional_0_Template, 1, 0, "ngx-spinner", 13)(1, BankCardComponent_Conditional_4_Conditional_9_Conditional_0_Conditional_1_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(0, ctx_r0.showOwnerLoading() ? 0 : 1);
  }
}
function BankCardComponent_Conditional_4_Conditional_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.ownerName(), " ");
  }
}
function BankCardComponent_Conditional_4_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BankCardComponent_Conditional_4_Conditional_9_Conditional_0_Template, 2, 1)(1, BankCardComponent_Conditional_4_Conditional_9_Conditional_1_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(0, ctx_r0.isTyping() && !ctx_r0.ownerName() ? 0 : 1);
  }
}
function BankCardComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, BankCardComponent_Conditional_4_Conditional_1_Template, 2, 1)(2, BankCardComponent_Conditional_4_Conditional_2_Template, 2, 0)(3, BankCardComponent_Conditional_4_Conditional_3_Template, 1, 3, "ui-api-image", 8)(4, BankCardComponent_Conditional_4_Conditional_4_Template, 1, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵtemplate(6, BankCardComponent_Conditional_4_Conditional_6_Template, 1, 1, "img", 10)(7, BankCardComponent_Conditional_4_Conditional_7_Template, 2, 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 7);
    i0.ɵɵtemplate(9, BankCardComponent_Conditional_4_Conditional_9_Template, 2, 1);
    i0.ɵɵelementStart(10, "p", 11);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r0.cardNumber() ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(3, ((tmp_2_0 = ctx_r0.changeSignal()) == null ? null : tmp_2_0.cardBankLogoImageId) ? 3 : 4);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(6, !ctx_r0.cardFound() && ctx_r0.cardNumber() ? 6 : 7);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(9, !ctx_r0.disabled() ? 9 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.expireDate());
  }
}
function BankCardComponent_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-api-image", 8);
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("imageId", (tmp_2_0 = ctx_r0.changeSignal()) == null ? null : tmp_2_0.cardBankLogoImageId)("width", ctx_r0.logoWidth() + "px")("height", ctx_r0.logoHeight() + "px");
  }
}
function BankCardComponent_Conditional_5_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("width", ctx_r0.logoWidth())("height", ctx_r0.logoHeight())("src", ctx_r0.Icons.DEFUALT_CARD, i0.ɵɵsanitizeUrl);
  }
}
function BankCardComponent_Conditional_5_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.alias(), " ");
  }
}
function BankCardComponent_Conditional_5_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" \u0628\u0627\u0646\u06A9 ", (tmp_3_0 = ctx_r0.changeSignal()) == null ? null : tmp_3_0.name, " ");
  }
}
function BankCardComponent_Conditional_5_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BankCardComponent_Conditional_5_Conditional_4_Conditional_0_Template, 2, 1, "p", 11)(1, BankCardComponent_Conditional_5_Conditional_4_Conditional_1_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(0, ctx_r0.alias() ? 0 : 1);
  }
}
function BankCardComponent_Conditional_5_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1, " \u06A9\u0627\u0631\u062A \u062C\u062F\u06CC\u062F ");
    i0.ɵɵelementEnd();
  }
}
function BankCardComponent_Conditional_5_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.ownerName(), " ");
  }
}
function BankCardComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 14);
    i0.ɵɵtemplate(2, BankCardComponent_Conditional_5_Conditional_2_Template, 1, 3, "ui-api-image", 8)(3, BankCardComponent_Conditional_5_Conditional_3_Template, 1, 3)(4, BankCardComponent_Conditional_5_Conditional_4_Template, 2, 1)(5, BankCardComponent_Conditional_5_Conditional_5_Template, 2, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cardNumber");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵtemplate(10, BankCardComponent_Conditional_5_Conditional_10_Template, 2, 1, "p", 11);
    i0.ɵɵelementStart(11, "p", 11);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(2, ((tmp_1_0 = ctx_r0.changeSignal()) == null ? null : tmp_1_0.cardBankLogoImageId) ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(4, ctx_r0.cardNumber() ? 4 : 5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(8, 5, ctx_r0.cardNumber(), " "), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(10, !ctx_r0.disabled() ? 10 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.expireDate());
  }
}
function WalletCardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "p", 3);
    i0.ɵɵtext(2, "\u06A9\u06CC\u0641 \u067E\u0648\u0644");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "img", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "thousands");
    i0.ɵɵelementStart(7, "span", 6);
    i0.ɵɵtext(8, " \u0631\u06CC\u0627\u0644");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵelementContainer(10, 8)(11, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", ctx_r0.logoWidth())("height", ctx_r0.logoHeight())("src", ctx_r0.Icons.DIGIPAY, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, ctx_r0.amount()), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.leftDetail());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rightDetail());
  }
}
function WalletCardComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11);
    i0.ɵɵelement(3, "img", 12);
    i0.ɵɵelementStart(4, "p", 3);
    i0.ɵɵtext(5, "\u06A9\u06CC\u0641 \u067E\u0648\u0644");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "p", 13);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "thousands");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 14);
    i0.ɵɵelementContainer(10, 8)(11, 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", ctx_r0.logoWidth())("height", ctx_r0.logoHeight())("src", ctx_r0.Icons.DIGIPAY, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 6, ctx_r0.amount()), " \u0631\u06CC\u0627\u0644 ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rightDetail());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.leftDetail());
  }
}
const _c0 = a0 => ({
  background: a0
});
function CreditCardComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-api-image", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("width", ctx_r0.logoWidth() + "px")("height", ctx_r0.logoHeight() + "px")("imageId", ctx_r0.cardLogo());
  }
}
function CreditCardComponent_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("width", ctx_r0.logoWidth())("height", ctx_r0.logoHeight())("src", ctx_r0.Icons.DIGIPAY, i0.ɵɵsanitizeUrl)("alt", ctx_r0.cardLabel() || "\u06A9\u06CC\u0641 \u0627\u0639\u062A\u0628\u0627\u0631\u06CC");
  }
}
function CreditCardComponent_Conditional_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.mainLabel(), " ");
  }
}
function CreditCardComponent_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "thousands");
    i0.ɵɵelementStart(3, "span", 10);
    i0.ɵɵtext(4, " \u0631\u06CC\u0627\u0644");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.amountAlign() == "left" ? "justify-content-flex-end" : ctx_r0.amountAlign() == "right" ? "justify-content-flex-start" : "justify-content-center");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r0.amount()), " ");
  }
}
function CreditCardComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
    i0.ɵɵelementStart(1, "div", 2)(2, "p", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreditCardComponent_Conditional_1_Conditional_4_Template, 1, 3, "ui-api-image", 4)(5, CreditCardComponent_Conditional_1_Conditional_5_Template, 1, 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CreditCardComponent_Conditional_1_Conditional_6_Template, 2, 1, "div", 5)(7, CreditCardComponent_Conditional_1_Conditional_7_Template, 5, 4);
    i0.ɵɵelementStart(8, "div", 6);
    i0.ɵɵelementContainer(9, 7)(10, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.Icons.BACKGROUND_LINER_2, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cardLabel() || "\u06A9\u06CC\u0641 \u0627\u0639\u062A\u0628\u0627\u0631\u06CC", " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(4, ctx_r0.cardLogo() ? 4 : 5);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(6, ctx_r0.mainLabel() ? 6 : 7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rightDetail());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.leftDetail());
  }
}
function CreditCardComponent_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-api-image", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("width", "20px")("height", "20px")("imageId", ctx_r0.cardLogo());
  }
}
function CreditCardComponent_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r0.Icons.DIGIPAY, i0.ɵɵsanitizeUrl)("alt", ctx_r0.cardLabel() || "\u06A9\u06CC\u0641 \u0627\u0639\u062A\u0628\u0627\u0631\u06CC");
  }
}
function CreditCardComponent_Conditional_2_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.mainLabel(), " ");
  }
}
function CreditCardComponent_Conditional_2_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "thousands");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.amount()), " \u0631\u06CC\u0627\u0644 ");
  }
}
function CreditCardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "div", 13);
    i0.ɵɵtemplate(3, CreditCardComponent_Conditional_2_Conditional_3_Template, 1, 3, "ui-api-image", 4)(4, CreditCardComponent_Conditional_2_Conditional_4_Template, 1, 2);
    i0.ɵɵelementStart(5, "p", 14);
    i0.ɵɵtext(6, "\u06A9\u06CC\u0641 \u067E\u0648\u0644");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "p", 15);
    i0.ɵɵtemplate(8, CreditCardComponent_Conditional_2_Conditional_8_Template, 1, 1)(9, CreditCardComponent_Conditional_2_Conditional_9_Template, 2, 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(10, "div");
    i0.ɵɵelementStart(11, "div", 16);
    i0.ɵɵelementContainer(12, 7)(13, 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(3, ctx_r0.cardLogo() ? 3 : 4);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(8, ctx_r0.mainLabel() ? 8 : 9);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rightDetail());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.leftDetail());
  }
}
function NgxCard_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lib-ngx-skeleton-loading", 0);
  }
}
function NgxCard_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "ngx-icon", 2);
    i0.ɵɵelementEnd();
  }
}
function NgxCard_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bank-card", 3);
    i0.ɵɵlistener("onClickNewCard", function NgxCard_Case_2_Template_bank_card_onClickNewCard_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNewClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cardSize", ctx_r1.cardSize())("disabled", ctx_r1.disabled())("ownerName", ctx_r1.ownerName())("expireDate", ctx_r1.expireDate())("cardNumber", ctx_r1.cardNumber())("alias", ctx_r1.alias())("isTyping", ctx_r1.isTyping())("showOwnerLoading", ctx_r1.showOwnerLoading())("logoWidth", ctx_r1.logoWidth())("logoHeight", ctx_r1.logoWidth());
  }
}
function NgxCard_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "credit-card", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cardSize", ctx_r1.cardSize())("amount", ctx_r1.amount())("leftDetail", ctx_r1.leftDetail())("rightDetail", ctx_r1.rightDetail())("cardLogo", ctx_r1.cardLogo())("cardLabel", ctx_r1.cardLabel())("mainLabel", ctx_r1.mainLabel())("isBnpl", true)("logoWidth", ctx_r1.logoWidth())("logoHeight", ctx_r1.logoWidth())("cardBackground", ctx_r1.cardBackground())("amountAlign", ctx_r1.amountAlign());
  }
}
function NgxCard_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "credit-card", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("amountAlign", ctx_r1.amountAlign())("cardBackground", ctx_r1.cardBackground())("cardSize", ctx_r1.cardSize())("amount", ctx_r1.amount())("leftDetail", ctx_r1.leftDetail())("rightDetail", ctx_r1.rightDetail())("mainLabel", ctx_r1.mainLabel())("cardLogo", ctx_r1.cardLogo())("cardLabel", ctx_r1.cardLabel())("isBnpl", false)("logoWidth", ctx_r1.logoWidth())("logoHeight", ctx_r1.logoWidth());
  }
}
function NgxCard_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wallet-card", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ownerName", ctx_r1.ownerName())("cardSize", ctx_r1.cardSize())("leftDetail", ctx_r1.leftDetail())("rightDetail", ctx_r1.rightDetail())("amount", ctx_r1.amount())("logoWidth", ctx_r1.logoWidth())("logoHeight", ctx_r1.logoWidth());
  }
}
function NgxCard_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "custom-card", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cardBackground", ctx_r1.cardBackground())("customTopRightDetail", ctx_r1.customTopRightDetail())("customTopLeftDetail", ctx_r1.customTopLeftDetail())("customBottomRightDetail", ctx_r1.customBottomRightDetail())("customBottomLeftDetail", ctx_r1.customBottomLeftDetail())("width", ctx_r1.width())("height", ctx_r1.height());
  }
}
class FindBank {
  constructor() {
    this.Banks = {
      "banks": [{
        "name": "تجارت",
        "code": "018",
        "active": true,
        "cardPrefixes": ["627353", "585983"],
        "uid": "98c92d3c-3960-449d-a654-18c07ee20b71",
        "imageId": "bank_018",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-018",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [10659, 10659],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "خاورمیانه",
        "code": "078",
        "active": true,
        "cardPrefixes": ["585947"],
        "uid": "7400c701-e625-4db0-9622-b8c0ff377f1c",
        "imageId": "bank_078",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-078",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [16744448, 16744448],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سامان",
        "code": "056",
        "active": true,
        "cardPrefixes": ["621986"],
        "uid": "ed745a50-9fea-4dcd-8c9c-90783e350a5f",
        "imageId": "bank_056",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-056",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [38143, 38143],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سپه (انصار)",
        "code": "063",
        "active": true,
        "cardPrefixes": ["627381"],
        "uid": "9fa5f46b-d011-43b4-9723-351d7e49db93",
        "imageId": "bank_015",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-015",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [10710272, 10710272],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سپه (قوامین)",
        "code": "052",
        "active": true,
        "cardPrefixes": ["639599"],
        "uid": "e47774bc-fa19-43e6-85a6-949fbcbe6203",
        "imageId": "bank_015",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-052",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [36679, 36679],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "اقتصاد نوین",
        "code": "055",
        "active": true,
        "cardPrefixes": ["627412"],
        "uid": "70e3128c-f5dc-4f09-949b-cd7c2b2864b2",
        "imageId": "bank_055",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-055",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [7078051, 7078051],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "پارسيان",
        "code": "054",
        "active": true,
        "cardPrefixes": ["622106"],
        "uid": "dd6bbc73-7f2f-4b7f-88b6-d880990fd2dd",
        "imageId": "bank_054",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-054",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [13400381, 13400381],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "پاسارگاد",
        "code": "057",
        "active": true,
        "cardPrefixes": ["502229"],
        "uid": "575859dc-4e74-44db-aa60-6ffb40f18cf3",
        "imageId": "bank_057",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-057",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [3354926, 3354926],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "پست بانک ایران",
        "code": "021",
        "active": true,
        "cardPrefixes": ["627760"],
        "uid": "b1d19484-ceb8-42a7-913e-f357c5e55289",
        "imageId": "bank_021",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-021",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [41791, 41791],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "توسعه صادرات",
        "code": "020",
        "active": false,
        "cardPrefixes": ["627648"],
        "uid": "f158bcd4-f71d-42d6-ae9f-41334ea61fc9",
        "imageId": "bank_020",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-020",
        "shouldVerify": false,
        "providerImages": ["pot", "digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_ft_tosan",
        "xferCertFileUrl": null,
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [41747, 41747],
        "transferAmountMin": 10000,
        "transferAmountMax": 30000000,
        "badge": {
          "value": "به زودی",
          "textColor": "#ffffff",
          "backgroundColor": "#ff811a",
          "borderColor": "#ff811a",
          "message": "در حال حاضر انتقال وجه از بانک توسعه صادرات امکان پذیر نیست."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "رفاه",
        "code": "013",
        "active": true,
        "cardPrefixes": ["589463"],
        "uid": "1062d99f-b2e6-46e2-9fc2-84d2ac1b901c",
        "imageId": "bank_013",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-013",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [24739, 24739],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سپه",
        "code": "015",
        "active": true,
        "cardPrefixes": ["589210"],
        "uid": "3ecbddbf-68e7-4505-b5a0-bed375feb410",
        "imageId": "bank_015",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-015",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [16733440, 16733440],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سرمایه",
        "code": "058",
        "active": false,
        "cardPrefixes": ["639607"],
        "uid": "38988837-d0f7-4b5b-b4cc-ca85657624b6",
        "imageId": "bank_058",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-058",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_ft_tosan",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_ft_tosan",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [786575, 786575],
        "transferAmountMin": 10000,
        "transferAmountMax": 30000000,
        "badge": {
          "value": "غیرفعال",
          "textColor": "#ffffff",
          "backgroundColor": "#6e798d",
          "borderColor": "#6e798d",
          "message": "انتقال وجه از بانک سرمایه موقتا غیرفعال می باشد."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "صادرات ایران",
        "code": "019",
        "active": false,
        "cardPrefixes": ["603769"],
        "uid": "025f16d1-a655-46e6-b5d5-077287dbc9e2",
        "imageId": "bank_019",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-019",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [1966223, 1966223],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": {
          "value": "غیرفعال",
          "textColor": "#ffffff",
          "backgroundColor": "#778599",
          "borderColor": "#ffffff",
          "message": "انتقال وجه از بانک صادرات ایران موقتا غیرفعال می باشد."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "صنعت و معدن",
        "code": "011",
        "active": true,
        "cardPrefixes": ["627961"],
        "uid": "fe80931a-a4c5-4e04-840d-ab8a71e5e097",
        "imageId": "bank_011",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-011",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [10715713, 10715713],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "کارآفرین",
        "code": "053",
        "active": false,
        "cardPrefixes": ["627488"],
        "uid": "40988e37-a5f0-4de4-a9eb-1d2e5bc104b0",
        "imageId": "bank_053",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-053",
        "shouldVerify": false,
        "providerImages": ["pot", "digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_ft_irkish",
        "xferCertFileUrl": null,
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [41728, 41728],
        "transferAmountMin": 10000,
        "transferAmountMax": 10000000,
        "badge": {
          "value": "به زودی",
          "textColor": "#ffffff",
          "backgroundColor": "#ff811a",
          "borderColor": "#ff811a",
          "message": "در حال حاضر انتقال وجه از بانک کارآفرین امکان پذیر نیست."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "کشاورزی",
        "code": "016",
        "active": true,
        "cardPrefixes": ["603770"],
        "uid": "e99030c3-8239-4251-84f2-567657f24967",
        "imageId": "bank_016",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-016",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [2254336, 2254336],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "مسکن",
        "code": "014",
        "active": true,
        "cardPrefixes": ["628023"],
        "uid": "f989f28d-63cc-49f5-b93f-f3e7797d2bbe",
        "imageId": "bank_014",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-014",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [16725504, 16725504],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "ملت",
        "code": "012",
        "active": true,
        "cardPrefixes": ["610433"],
        "uid": "32bfebff-7a80-4828-89a5-893841713132",
        "imageId": "bank_012",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-012",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [16724838, 16724838],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سینا",
        "code": "059",
        "active": true,
        "cardPrefixes": ["639346"],
        "uid": "2b01b636-1b27-46f4-8d45-5eb47bbf44ff",
        "imageId": "bank_059",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-059",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [26316, 26316],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "موسسه مالی توسعه",
        "code": "051",
        "active": false,
        "cardPrefixes": ["628157"],
        "uid": "e9c7091b-fa8a-4535-9cde-0399c70d9773",
        "imageId": "bank_051",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-051",
        "shouldVerify": false,
        "providerImages": ["pot", "digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_ft_irkishnew",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_ft_irkishnew",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [13369344, 13369344],
        "transferAmountMin": 10000,
        "transferAmountMax": 10000000,
        "badge": {
          "value": "غیرفعال",
          "textColor": "#ffffff",
          "backgroundColor": "#6e798d",
          "borderColor": "#6e798d",
          "message": "انتقال وجه از موسسه مالی توسعه موقتا غیرفعال می باشد."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "رسالت",
        "code": "070",
        "active": false,
        "cardPrefixes": ["504172"],
        "uid": "45d90199-d657-4217-ae25-f2fcd9d1d19a",
        "imageId": "bank_070",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-070",
        "shouldVerify": false,
        "providerImages": ["pot", "digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_ft_tosan",
        "xferCertFileUrl": null,
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [41891, 41891],
        "transferAmountMin": 10000,
        "transferAmountMax": 30000000,
        "badge": {
          "value": "به زودی",
          "textColor": "#ffffff",
          "backgroundColor": "#ff811a",
          "borderColor": "#ff811a",
          "message": "در حال حاضر انتقال وجه از بانک رسالت امکان پذیر نیست."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "گردشگری",
        "code": "064",
        "active": true,
        "cardPrefixes": ["505416"],
        "uid": "418eff9d-17b3-4292-856a-721ce3b7fe7c",
        "imageId": "bank_064",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-064",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [10682382, 10682382],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "توسعه تعاون",
        "code": "022",
        "active": false,
        "cardPrefixes": ["502908"],
        "uid": "81a8f959-c262-42aa-b879-1c6dbfaabed3",
        "imageId": "bank_022",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-022",
        "shouldVerify": false,
        "providerImages": ["pot", "digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_ft_tosan",
        "xferCertFileUrl": null,
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [48844, 48844],
        "transferAmountMin": 10000,
        "transferAmountMax": 30000000,
        "badge": {
          "value": "به زودی",
          "textColor": "#ffffff",
          "backgroundColor": "#ff811a",
          "borderColor": "#ff811a",
          "message": "در حال حاضر انتقال وجه از بانک توسعه تعاون امکان پذیر نیست."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سپه (حکمت)",
        "code": "065",
        "active": true,
        "cardPrefixes": ["636949"],
        "uid": "c69070f6-17f7-4293-9ef5-142259632475",
        "imageId": "bank_015",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-015",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [16733440, 16733440],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سپه (کوثر)",
        "code": "073",
        "active": true,
        "cardPrefixes": ["505801"],
        "uid": "3f7b03dc-c4ae-46f8-b861-d2a96decff2b",
        "imageId": "bank_015",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-015",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [9371750, 9371750],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "موسسه ملل",
        "code": "075",
        "active": true,
        "cardPrefixes": ["606256"],
        "uid": "242b5279-0ad4-4105-8ab6-a37c06325b03",
        "imageId": "bank_075",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-075",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [16739328, 16739328],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "دی",
        "code": "066",
        "active": true,
        "cardPrefixes": ["502938"],
        "uid": "46582a2b-3a62-49a9-8ef0-19e24ee67ee0",
        "imageId": "bank_066",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-066",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [44492, 44492],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "ایران زمین",
        "code": "069",
        "active": true,
        "cardPrefixes": ["505785"],
        "uid": "90b5cfb0-7920-46b2-a2b1-9bf0e29c3e31",
        "imageId": "bank_069",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-069",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [13369480, 13369480],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "شهر",
        "code": "061",
        "active": true,
        "cardPrefixes": ["502806", "504706"],
        "uid": "00db1849-334d-4834-b02e-5775c902d847",
        "imageId": "bank_061",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-061",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [16718105, 16718105],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "آینده",
        "code": "062",
        "active": false,
        "cardPrefixes": ["636214"],
        "uid": "9c563ca2-cc74-4429-96f6-1cb35b9fed14",
        "imageId": "bank_062",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-062",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_ft_finotech",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_ft_finotech",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [6695168, 6695168],
        "transferAmountMin": 10000,
        "transferAmountMax": 10000000,
        "badge": {
          "value": "غیرفعال",
          "textColor": "#ffffff",
          "backgroundColor": "#6e798d",
          "borderColor": "#6e798d",
          "message": "انتقال وجه از بانک آینده موقتا غیرفعال می باشد."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "ملی ايران",
        "code": "017",
        "active": true,
        "cardPrefixes": ["603799"],
        "uid": "874ba953-5951-4f0b-9943-22a86f538a5e",
        "imageId": "bank_017",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-017",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [24806, 24806],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "مهر ایران",
        "code": "060",
        "active": true,
        "cardPrefixes": ["606373"],
        "uid": "f26b2d19-9d37-4d96-9b37-cd1dfeaafac0",
        "imageId": "bank_060",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-060",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [6202112, 6202112],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "ایران ونزویلا",
        "code": "095",
        "active": false,
        "cardPrefixes": ["581874"],
        "uid": "2780bdfd-f910-458e-b9c1-d719e83c1bb4",
        "imageId": "bank_095",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-095",
        "shouldVerify": false,
        "providerImages": ["pot", "digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_ft_tosan",
        "xferCertFileUrl": null,
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [7832985, 7832985],
        "transferAmountMin": 10000,
        "transferAmountMax": 30000000,
        "badge": {
          "value": "به زودی",
          "textColor": "#ffffff",
          "backgroundColor": "#ff811a",
          "borderColor": "#ff811a",
          "message": "در حال حاضر انتقال وجه از بانک ایران ونزويلا امکان پذیر نیست."
        },
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "نور",
        "code": "080",
        "active": true,
        "cardPrefixes": ["507677"],
        "uid": "3e235d8c-087b-4182-82ff-b69f1fe3a530",
        "imageId": "bank_080",
        "cardImageId": "bank-dark-pattern-image",
        "cardBankLogoImageId": "logo-bank-080",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [17315, 17315],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }, {
        "name": "سپه (مهر)",
        "code": "120",
        "active": true,
        "cardPrefixes": ["639370"],
        "uid": "3cfae04e-1fa5-48df-81cd-4d4d45a9e60b",
        "imageId": "bank_015",
        "cardImageId": "bank-light-pattern-image",
        "cardBankLogoImageId": "logo-bank-015",
        "shouldVerify": false,
        "providerImages": ["digipay_thumbnail", "bank_010"],
        "xferCert": "cert_file_pisp_shaparak",
        "xferCertFileUrl": "/digipay/api/certs/cert_file_pisp_shaparak",
        "profileCert": "cert_file_ft_venesh",
        "profileCertUrl": "/digipay/api/certs/cert_file_ft_venesh",
        "colorRange": [16733440, 16733440],
        "transferAmountMin": 10000,
        "transferAmountMax": 50000000,
        "badge": null,
        "directDebit": null,
        "cardExternalRegistrationMode": 0
      }],
      "maxTimeout": 600000
    };
  }
  findBankByCardPrefixes(cardPrefixes) {
    return this.Banks.banks.find(bank => bank.cardPrefixes.includes(cardPrefixes));
  }
}
var Icons = /*#__PURE__*/function (Icons) {
  Icons["NEW"] = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1NjE2XzMwMCkiPgo8bWFzayBpZD0ibWFzazBfMTU2MTZfMzAwIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPgo8cGF0aCBkPSJNNSAxMEgxNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwIDVWMTUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8xNTYxNl8zMDApIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjMDAwMDYwIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xNTYxNl8zMDAiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
  Icons["EMPTY"] = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgyIiBoZWlnaHQ9IjIiIHZpZXdCb3g9IjAgMCAxODIgMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSAxSDM2LjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMC42NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSIwLjAxIDQiLz4KPHBhdGggZD0iTTQ5LjUgMUg4NC41IiBzdHJva2U9IiNCNEI3QkQiIHN0cm9rZS13aWR0aD0iMC42NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSIwLjAxIDQiLz4KPHBhdGggZD0iTTk3LjUgMUgxMzIuNSIgc3Ryb2tlPSIjQjRCN0JEIiBzdHJva2Utd2lkdGg9IjAuNjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWRhc2hhcnJheT0iMC4wMSA0Ii8+CjxwYXRoIGQ9Ik0xNDUuNSAxSDE4MS41IiBzdHJva2U9IiNCNEI3QkQiIHN0cm9rZS13aWR0aD0iMC42NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSIwLjAxIDQiLz4KPC9zdmc+Cg==";
  Icons["DEFUALT_CARD"] = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkRQIExvZ28iPgo8cGF0aCBpZD0iVmVjdG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjY2NjcgNy41NjU4OEMxNy44MDQ4IDcuNTY1ODggMTcuOTE2NyA3LjQ1Mzk2IDE3LjkxNjcgNy4zMTU4OFY3LjI1NzU1QzE3LjkxNjcgNC45MzAwNSAxNi40MjE3IDMuMzY1ODggMTQuMTk1OCAzLjM2NTg4SDUuODAzMzdDMy41NzgzNyAzLjM2NTg4IDIuMDgzMzcgNC45MzAwNSAyLjA4MzM3IDcuMjU3NTVWNy4zMTU4OEMyLjA4MzM3IDcuNDUzOTYgMi4xOTUzMSA3LjU2NTg4IDIuMzMzMzcgNy41NjU4OEgxNy42NjY3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNDU0NjEgMTMuMjY1OUg1Ljk4MDQ1QzUuNjM1NDUgMTMuMjY1OSA1LjM1NTQ1IDEyLjk4NTkgNS4zNTU0NSAxMi42NDA5QzUuMzU1NDUgMTIuMjk1OSA1LjYzNTQ1IDEyLjAxNTkgNS45ODA0NSAxMi4wMTU5SDguNDU0NjFDOC43OTk2MSAxMi4wMTU5IDkuMDc5NjEgMTIuMjk1OSA5LjA3OTYxIDEyLjY0MDlDOS4wNzk2MSAxMi45ODU5IDguNzk5NjEgMTMuMjY1OSA4LjQ1NDYxIDEzLjI2NTlaTTIuMzMyOTUgOC44MTU5MkMyLjE5NDg4IDguODE1OTIgMi4wODI5NSA4LjkyNzgzIDIuMDgyOTUgOS4wNjU5MlYxMi43NDA5QzIuMDgyOTUgMTUuMDY4NCAzLjU3Nzk1IDE2LjYzMjYgNS44MDI5NSAxNi42MzI2SDE0LjE5NTRDMTYuNDIxMyAxNi42MzI2IDE3LjkxNjMgMTUuMDY4NCAxNy45MTYzIDEyLjc0MDlWOS4wNjU5MkMxNy45MTYzIDguOTI3ODMgMTcuODA0NCA4LjgxNTkyIDE3LjY2NjMgOC44MTU5MkgyLjMzMjk1WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K";
  Icons["BACKGROUND_LINER_1"] = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMTYiIGhlaWdodD0iMTQ0IiB2aWV3Qm94PSIwIDAgMjE2IDE0NCIgZmlsbD0ibm9uZSI+CiAgPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE0NjI2XzEyMzE2KSI+CiAgICA8bWFzayBpZD0ibWFzazBfMTQ2MjZfMTIzMTYiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMTYiIGhlaWdodD0iMTQ0Ij4KICAgICAgPHJlY3Qgd2lkdGg9IjIxNiIgaGVpZ2h0PSIxNDQiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNDYyNl8xMjMxNikiLz4KICAgIDwvbWFzaz4KICAgIDxnIG1hc2s9InVybCgjbWFzazBfMTQ2MjZfMTIzMTYpIj4KICAgICAgPHJlY3Qgd2lkdGg9IjIxNiIgaGVpZ2h0PSIxNDQiLz4KICAgICAgPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOnBsdXMtZGFya2VyIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMjE2IiBoZWlnaHQ9IjE0NCIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzE0NjI2XzEyMzE2KSIgZmlsbC1vcGFjaXR5PSIwLjM1Ii8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTQ2MjZfMTIzMTYiIHgxPSIyMTYiIHkxPSItMS4wMzkzNmUtMDUiIHgyPSItMTYuNSIgeTI9IjEzNy41IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLW9wYWNpdHk9IjAuNyIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl8xNDYyNl8xMjMxNiIgeDE9IjIxNiIgeTE9IjE0NCIgeDI9IjcuMTUyNTZlLTA3IiB5Mj0iLTEuMDcyODhlLTA2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLW9wYWNpdHk9IjAiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzE0NjI2XzEyMzE2Ij4KICAgICAgPHJlY3Qgd2lkdGg9IjIxNiIgaGVpZ2h0PSIxNDQiIGZpbGw9IndoaXRlIi8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+Cg==";
  Icons["DIGIPAY"] = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljc5ODExIDcuODEyOTdMMTUgNy44MTI1MVY4LjU3OTM5QzE1IDkuODY5ODUgMTQuODU1IDEwLjM5MiAxNC41ODI2IDEwLjkwMTNDMTQuMzEwMyAxMS40MTA2IDEzLjkxMDYgMTEuODEwMiAxMy40MDEzIDEyLjA4MjZDMTIuOTI0OSAxMi4zMzc0IDEyLjQzNzIgMTIuNDgwOCAxMS4zMTk3IDEyLjQ5ODJMMTEuMDc5NCAxMi41SDEwVjEzLjQ5MzlDMTAgMTQuODg2OSA5Ljg1NDk2IDE1LjM5MiA5LjU4MjYyIDE1LjkwMTNDOS4zMTAyOCAxNi40MTA2IDguOTEwNTkgMTYuODEwMiA4LjQwMTM0IDE3LjA4MjZMOC4zMDg1OSAxNy4xMzA3QzcuODQzMDkgMTcuMzY0MiA3LjMzNjM0IDE3LjQ5MTYgNi4xMTgxNSAxNy40OTk2TDUuOTkzOTQgMTcuNUg1VjExLjczMzFMNS4wMDE4MSAxMS40OTI4QzUuMDE5MjUgMTAuMzc1MyA1LjE2MjYxIDkuODg3NTkgNS40MTc0MSA5LjQxMTE3QzUuNjg5NzggOC45MDE5MiA2LjA4OTQ0IDguNTAyMjYgNi41OTg2OSA4LjIyOTg5QzcuMDkxNTEgNy45NjYzMyA3LjU5NjQ4IDcuODIyIDguNzk4MTEgNy44MTI5N1pNNSAyLjVIMTEuMDc5NEwxMS4zMTk3IDIuNTAxODFDMTIuNDM3MiAyLjUxOTI1IDEyLjkyNDkgMi42NjI2MyAxMy40MDEzIDIuOTE3NDFDMTMuOTEwNiAzLjE4OTc4IDE0LjMxMDMgMy41ODk0NCAxNC41ODI2IDQuMDk4NjlDMTQuODQ2MiA0LjU5MTUxIDE0Ljk5MDUgNS4wOTY0NyAxNC45OTk1IDYuMjk4MTFMMTUgNy4xODc0OUg4LjkyMDYyQzcuNjMwMTUgNy4xODc0OSA3LjEwNzk3IDcuMDQyNDYgNi41OTg2OSA2Ljc3MDEyQzYuMDg5NDQgNi40OTc3NCA1LjY4OTc4IDYuMDk4MDkgNS40MTc0MSA1LjU4ODg0QzUuMTYyNjMgNS4xMTI0MiA1LjAxOTI1IDQuNjI0NjcgNS4wMDE4MSAzLjUwNzI1TDUgMy4yNjY4N1YyLjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
  Icons["BACKGROUND_LINER_2"] = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMTYiIGhlaWdodD0iMTQ0IiB2aWV3Qm94PSIwIDAgMjE2IDE0NCIgZmlsbD0ibm9uZSI+DQogIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xNDYyNl8xMjMxNikiPg0KICAgIDxtYXNrIGlkPSJtYXNrMF8xNDYyNl8xMjMxNiIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjIxNiIgaGVpZ2h0PSIxNDQiPg0KICAgICAgPHJlY3Qgd2lkdGg9IjIxNiIgaGVpZ2h0PSIxNDQiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNDYyNl8xMjMxNikiLz4NCiAgICA8L21hc2s+DQogICAgPGcgbWFzaz0idXJsKCNtYXNrMF8xNDYyNl8xMjMxNikiPg0KICAgICAgPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOnBsdXMtZGFya2VyIj4NCiAgICAgICAgPHJlY3Qgd2lkdGg9IjIxNiIgaGVpZ2h0PSIxNDQiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcl8xNDYyNl8xMjMxNikiIGZpbGwtb3BhY2l0eT0iMC4zNSIvPg0KICAgICAgPC9nPg0KICAgIDwvZz4NCiAgPC9nPg0KICA8ZGVmcz4NCiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTQ2MjZfMTIzMTYiIHgxPSIyMTYiIHkxPSItMS4wMzkzNmUtMDUiIHgyPSItMTYuNSIgeTI9IjEzNy41IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+DQogICAgICA8c3RvcC8+DQogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3Atb3BhY2l0eT0iMC43Ii8+DQogICAgPC9saW5lYXJHcmFkaWVudD4NCiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfMTQ2MjZfMTIzMTYiIHgxPSIyMTYiIHkxPSIxNDQiIHgyPSI3LjE1MjU2ZS0wNyIgeTI9Ii0xLjA3Mjg4ZS0wNiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPg0KICAgICAgPHN0b3AvPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLW9wYWNpdHk9IjAiLz4NCiAgICA8L2xpbmVhckdyYWRpZW50Pg0KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMTQ2MjZfMTIzMTYiPg0KICAgICAgPHJlY3Qgd2lkdGg9IjIxNiIgaGVpZ2h0PSIxNDQiIGZpbGw9IndoaXRlIi8+DQogICAgPC9jbGlwUGF0aD4NCiAgPC9kZWZzPg0KPC9zdmc+DQo=";
  Icons["BACKGROUND_TEMPLATE"] = "data:image/png;base64,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";
  return Icons;
}(Icons || {});
let BankCardComponent = /*#__PURE__*/(() => {
  class BankCardComponent {
    constructor() {
      this.bank = new FindBank();
      this.Icons = Icons;
      this.JSON = JSON;
      this.cardSize = input();
      this.disabled = input(false);
      this.ownerName = input('');
      this.expireDate = input('');
      this.cardNumber = input('');
      this.isTyping = input(false);
      this.showOwnerLoading = input(true);
      this.logoWidth = input(24);
      this.logoHeight = input(24);
      this.cardFound = computed(() => {
        const found = this.bank.findBankByCardPrefixes(this.cardNumber()?.substring(0, 6));
        return !!found;
      });
      this.changeSignal = computed(() => {
        const card = this.bank.findBankByCardPrefixes(this.cardNumber()?.substring(0, 6));
        if (!card || this.cardNumber()?.length > 16) {
          return null;
        } else {
          return card;
        }
      });
      this.alias = input(null);
      this.onClickNewCard = output();
      this.onSearchCard = output();
      effect(() => {
        this.changeSignal();
        if (this.cardNumber()?.length == 16) {
          this.onSearchCard.emit();
        }
      });
    }
    convertToRgb(value) {
      return ColorConverterService.convertDecimalToRgb(+value);
    }
    onNewClick() {
      this.onClickNewCard.emit();
    }
    static {
      this.ɵfac = function BankCardComponent_Factory(t) {
        return new (t || BankCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BankCardComponent,
        selectors: [["bank-card"]],
        inputs: {
          cardSize: [i0.ɵɵInputFlags.SignalBased, "cardSize"],
          disabled: [i0.ɵɵInputFlags.SignalBased, "disabled"],
          ownerName: [i0.ɵɵInputFlags.SignalBased, "ownerName"],
          expireDate: [i0.ɵɵInputFlags.SignalBased, "expireDate"],
          cardNumber: [i0.ɵɵInputFlags.SignalBased, "cardNumber"],
          isTyping: [i0.ɵɵInputFlags.SignalBased, "isTyping"],
          showOwnerLoading: [i0.ɵɵInputFlags.SignalBased, "showOwnerLoading"],
          logoWidth: [i0.ɵɵInputFlags.SignalBased, "logoWidth"],
          logoHeight: [i0.ɵɵInputFlags.SignalBased, "logoHeight"],
          alias: [i0.ɵɵInputFlags.SignalBased, "alias"]
        },
        outputs: {
          onClickNewCard: "onClickNewCard",
          onSearchCard: "onSearchCard"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 6,
        vars: 7,
        consts: [[1, "bank-container", "p-medium", "d-flex", "flex-column", "justify-content-space-between", "radius-plus", 3, "ngClass"], ["alt", "BACKGROUND_TEMPLATE", 1, "image-template", 3, "src"], [1, "card-disabled", "d-flex", "justify-content-center", "align-items-center", "radius-plus", "px-small", "py-tiny", "fs-10", 3, "size", "status"], [1, "empty-container", "d-flex", "flex-row"], [1, "new-card-placeholder"], [1, "new-card", "d-flex", "align-items-center", "justify-content-center", "radius-giant", 3, "click"], ["alt", "New", "width", "20px", "height", "20px", 3, "src"], [1, "d-flex", "flex-row", "justify-content-space-between"], [1, "logo", 3, "imageId", "width", "height"], [1, "card-middle", "fs-16"], ["alt", "Empty", 3, "src"], [1, "card-title", "fs-12", "m-atom"], ["alt", "Default", 3, "width", "height", "src"], ["size", "sm", "color", "white"], [1, "d-flex"], [1, "card-number-sm"]],
        template: function BankCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, BankCardComponent_Conditional_1_Template, 1, 1, "img", 1)(2, BankCardComponent_Conditional_2_Template, 2, 2, "ngx-badge", 2)(3, BankCardComponent_Conditional_3_Template, 2, 1)(4, BankCardComponent_Conditional_4_Template, 12, 5)(5, BankCardComponent_Conditional_5_Template, 13, 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵstyleProp("background", ctx.cardNumber() && ctx.cardFound() ? ctx.convertToRgb((tmp_0_0 = ctx.changeSignal()) == null ? null : tmp_0_0.colorRange[0]) : !ctx.cardFound() && ctx.cardNumber() ? "rgba(20, 21, 24, 0.9) !important" : "");
            i0.ɵɵproperty("ngClass", ctx.disabled() || !ctx.cardFound() && ctx.cardNumber() ? "blur-filter" : "");
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, !ctx.cardFound() && ctx.cardNumber() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(2, ctx.disabled() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(3, !ctx.cardNumber() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(4, ctx.cardSize() == "default" ? 4 : 5);
          }
        },
        dependencies: [NgClass, ApiImageModule, i1.ApiImageComponent, PipesModule, i1$1.CardNumberPipe, NgxSpinnerModule, i3.NgxSpinnerComponent, NgxBadgeModule, i4.NgxBadgeComponent],
        styles: [".bank-container[_ngcontent-%COMP%]{position:relative;background:linear-gradient(90deg,var(--onback-shade-60) 0%,#5C5E63 80%);flex-grow:1}.bank-container[_ngcontent-%COMP%]   .card-title[_ngcontent-%COMP%]{line-height:20px!important;text-align:left;color:var(--text-oninvert-high)}.bank-container[_ngcontent-%COMP%]   .card-image[_ngcontent-%COMP%]{width:20px;height:20px}.bank-container[_ngcontent-%COMP%]   .card-middle[_ngcontent-%COMP%]{color:var(--text-oninvert-high);line-height:normal;text-align:center;margin-top:14px;direction:ltr}.bank-container[_ngcontent-%COMP%]   .card-number-sm[_ngcontent-%COMP%]{color:var(--text-oninvert-high);font-size:14px;font-style:normal;font-weight:370;line-height:24px;direction:ltr}.new-card[_ngcontent-%COMP%]{background:var(--onback-shade-95);box-shadow:0 4px 8px #45474a0a;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;align-content:center;width:52px;height:36px;z-index:9}.empty-container[_ngcontent-%COMP%]{justify-content:space-around;position:absolute;top:55%;left:50%;width:95%;transform:translate(-50%,-50%)}.new-card-placeholder[_ngcontent-%COMP%]{margin:0;color:#b4b7bd;font-size:9px}.card-disabled[_ngcontent-%COMP%]{position:absolute;bottom:16px;right:16px;line-height:16px;z-index:10;padding:0!important}.card-bank-not-found[_ngcontent-%COMP%]{position:absolute;bottom:16px;right:16px;color:#000060;background:var(--onback-shade-95);width:98px;z-index:10;height:24px;cursor:pointer}.empty-expire-date[_ngcontent-%COMP%]{height:2px}.blur-filter[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:not(.card-disabled):not(.card-bank-not-found){-webkit-filter:blur(1px)}.background-image-gradiant[_ngcontent-%COMP%]{position:absolute;inset:0;pointer-events:none;width:100%;height:inherit;object-fit:cover}.background-image-gradiant-small[_ngcontent-%COMP%]{position:absolute;pointer-events:none;width:100%;top:0;left:0;right:0;height:inherit;object-fit:cover}.image-template[_ngcontent-%COMP%]{position:absolute;left:0;top:0;width:100%}"]
      });
    }
  }
  return BankCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WalletCardComponent = /*#__PURE__*/(() => {
  class WalletCardComponent {
    constructor() {
      this.ownerName = input('');
      this.amount = input();
      this.cardSize = input('default');
      this.Icons = Icons;
      this.rightDetail = input();
      this.leftDetail = input();
      this.logoWidth = input(24);
      this.logoHeight = input(24);
    }
    static {
      this.ɵfac = function WalletCardComponent_Factory(t) {
        return new (t || WalletCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WalletCardComponent,
        selectors: [["wallet-card"]],
        inputs: {
          ownerName: [i0.ɵɵInputFlags.SignalBased, "ownerName"],
          amount: [i0.ɵɵInputFlags.SignalBased, "amount"],
          cardSize: [i0.ɵɵInputFlags.SignalBased, "cardSize"],
          rightDetail: [i0.ɵɵInputFlags.SignalBased, "rightDetail"],
          leftDetail: [i0.ɵɵInputFlags.SignalBased, "leftDetail"],
          logoWidth: [i0.ɵɵInputFlags.SignalBased, "logoWidth"],
          logoHeight: [i0.ɵɵInputFlags.SignalBased, "logoHeight"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 2,
        consts: [[1, "credit-container", "p-medium", "d-flex", "flex-column", "justify-content-space-between", "radius-plus"], [1, "image-template", 3, "src"], [1, "d-flex", "flex-row", "justify-content-space-between", "card-header", "z-index-1"], [1, "credit-title", "m-atom", "c-3"], [3, "width", "height", "src"], [1, "credit-amount", "fs-24", "text-align-center", "mt-small", "card-main-value"], [1, "is-currency", "mr-low", "fw-light"], [1, "d-flex", "flex-row-reverse", "justify-content-space-between", "align-items-flex-end", "card-footer", "c-3"], [3, "ngTemplateOutlet"], [1, "d-flex", "flex-column", "justify-content-space-between"], [1, "d-flex", "flex-row", "justify-content-space-between"], [1, "d-flex", "flex-row"], [1, "ml-low", 3, "width", "height", "src"], [1, "credit-title", "m-atom", "fs-12", "is-currency"], [1, "d-flex", "flex-row", "justify-content-space-between", "align-items-flex-end"]],
        template: function WalletCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "img", 1);
            i0.ɵɵtemplate(2, WalletCardComponent_Conditional_2_Template, 12, 8)(3, WalletCardComponent_Conditional_3_Template, 12, 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("src", ctx.Icons.BACKGROUND_TEMPLATE, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵconditional(2, ctx.cardSize() == "default" ? 2 : 3);
          }
        },
        dependencies: [PipesModule, i1$1.SeparateThousandsPipe, NgTemplateOutlet],
        styles: [".credit-container[_ngcontent-%COMP%]{position:relative;background:#000;background:linear-gradient(270deg,#000 -60%,#1159fc 35%);display:flex;flex-direction:column;flex:1 1 auto}.credit-container[_ngcontent-%COMP%]:before{content:\"\";position:absolute;inset:0;background:linear-gradient(294deg,rgba(0,0,0,.35),transparent);mix-blend-mode:multiply;-webkit-backdrop-filter:saturate(1.2);backdrop-filter:saturate(1.2)}.credit-container[_ngcontent-%COMP%]   .card-header[_ngcontent-%COMP%]{flex:0 0 auto}.credit-container[_ngcontent-%COMP%]   .card-main-value[_ngcontent-%COMP%]{flex:1 1 auto;display:flex;justify-content:center;align-items:center}.credit-container[_ngcontent-%COMP%]   .card-footer[_ngcontent-%COMP%]{flex:0 0 auto}.credit-container[_ngcontent-%COMP%]   .background-image-gradient[_ngcontent-%COMP%]{position:absolute;inset:0;pointer-events:none;object-fit:cover;opacity:.5;width:100%;height:100%}.credit-container[_ngcontent-%COMP%]   .credit-logo[_ngcontent-%COMP%]{width:20px;height:20px}.credit-container[_ngcontent-%COMP%]   .credit-title[_ngcontent-%COMP%], .credit-container[_ngcontent-%COMP%]   .credit-amount[_ngcontent-%COMP%]{color:var(--text-oninvert-high)}.credit-container[_ngcontent-%COMP%]   .credit-amount[_ngcontent-%COMP%]{display:flex;overflow-x:clip;justify-content:center}.credit-container[_ngcontent-%COMP%]   .image-template[_ngcontent-%COMP%]{position:absolute;left:0;top:0}.credit-container[_ngcontent-%COMP%]   .z-index-1[_ngcontent-%COMP%]{z-index:1}"]
      });
    }
  }
  return WalletCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CreditCardComponent = /*#__PURE__*/(() => {
  class CreditCardComponent {
    constructor() {
      this.Icons = Icons;
      this.cardSize = input('default');
      this.rightDetail = input();
      this.leftDetail = input();
      this.amount = input();
      this.mainLabel = input();
      this.cardLabel = input();
      this.cardLogo = input();
      this.isBnpl = input(false);
      this.cardBackground = input('#099466');
      this.logoWidth = input(24);
      this.logoHeight = input(24);
      this.amountAlign = input('left');
    }
    static {
      this.ɵfac = function CreditCardComponent_Factory(t) {
        return new (t || CreditCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CreditCardComponent,
        selectors: [["credit-card"]],
        inputs: {
          cardSize: [i0.ɵɵInputFlags.SignalBased, "cardSize"],
          rightDetail: [i0.ɵɵInputFlags.SignalBased, "rightDetail"],
          leftDetail: [i0.ɵɵInputFlags.SignalBased, "leftDetail"],
          amount: [i0.ɵɵInputFlags.SignalBased, "amount"],
          mainLabel: [i0.ɵɵInputFlags.SignalBased, "mainLabel"],
          cardLabel: [i0.ɵɵInputFlags.SignalBased, "cardLabel"],
          cardLogo: [i0.ɵɵInputFlags.SignalBased, "cardLogo"],
          isBnpl: [i0.ɵɵInputFlags.SignalBased, "isBnpl"],
          cardBackground: [i0.ɵɵInputFlags.SignalBased, "cardBackground"],
          logoWidth: [i0.ɵɵInputFlags.SignalBased, "logoWidth"],
          logoHeight: [i0.ɵɵInputFlags.SignalBased, "logoHeight"],
          amountAlign: [i0.ɵɵInputFlags.SignalBased, "amountAlign"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 6,
        consts: [[3, "ngStyle"], [1, "background-image-gradiant", "radius-plus", 3, "src"], [1, "d-flex", "flex-row", "justify-content-space-between", "card-header"], [1, "wallet-title", "m-atom", "fs-12", "fw-normal"], [3, "width", "height", "imageId"], [1, "wallet-main-label", "b-3", "text-align-center", "mt-small", "card-main-value"], [1, "d-flex", "flex-row", "justify-content-space-between", "align-items-flex-end", "card-footer"], [3, "ngTemplateOutlet"], [3, "width", "height", "src", "alt"], [1, "wallet-amount", "fs-24", "mt-small", "card-main-value", 3, "ngClass"], [1, "is-currency", "mr-low", "fw-100"], [1, "d-flex", "flex-column", "justify-content-space-between"], [1, "d-flex", "flex-row", "justify-content-space-between"], [1, "d-flex", "flex-row"], [1, "wallet-title", "m-atom", "fs-12"], [1, "wallet-title", "m-atom", "fs-12", "is-currency"], [1, "d-flex", "flex-row", "justify-content-space-between", "align-items-flex-end"], [1, "wallet-logo", 3, "src", "alt"]],
        template: function CreditCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CreditCardComponent_Conditional_1_Template, 11, 6)(2, CreditCardComponent_Conditional_2_Template, 14, 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("wallet-container p-medium d-flex flex-column justify-content-space-between radius-plus" + (ctx.isBnpl() ? " is-bnpl" : ""));
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c0, ctx.cardBackground()));
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.cardSize() === "default" ? 1 : 2);
          }
        },
        dependencies: [NgTemplateOutlet, NgClass, PipesModule, i1$1.SeparateThousandsPipe, ApiImageModule, i1.ApiImageComponent, NgStyle],
        styles: [".wallet-container{position:relative;display:flex;flex-direction:column;flex:1 1 auto}.wallet-container:before{content:\"\";position:absolute;inset:0;background:linear-gradient(294deg,rgba(0,0,0,.35),transparent);-webkit-mix-blend-mode:multiply;mix-blend-mode:multiply;-webkit-backdrop-filter:saturate(1.2);backdrop-filter:saturate(1.2)}.wallet-container.is-bnpl{background:#7a53ff!important}.wallet-container .card-header{flex:0 0 auto;position:relative;z-index:1;align-items:center}.wallet-container .card-main-value{flex:1 1 auto;display:flex;justify-content:center;align-items:center;position:relative;z-index:1}.wallet-container .card-footer{flex:0 0 auto;position:relative;z-index:1}.wallet-container .background-image-gradiant{position:absolute;inset:0;pointer-events:none;width:100%;height:inherit;object-fit:cover;opacity:.5;z-index:0}.wallet-container .wallet-title{color:var(--text-oninvert-high)}.wallet-container .wallet-main-label{color:var(--text-oninvert-high);display:flex;overflow-x:clip;justify-content:center;font-feature-settings:\"ss01\" on}.wallet-container .wallet-amount{color:var(--text-oninvert-high);display:flex;overflow-x:clip;font-feature-settings:\"ss01\" on}.wallet-container .fw-100{font-weight:100}@supports (-webkit-backdrop-filter: none){.wallet-container:before{background-blend-mode:normal;-webkit-backdrop-filter:none;backdrop-filter:none}}\n"],
        encapsulation: 2
      });
    }
  }
  return CreditCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomCardComponent = /*#__PURE__*/(() => {
  class CustomCardComponent {
    constructor() {
      this.cardBackground = input('#099466');
      this.customTopRightDetail = input();
      this.customTopLeftDetail = input();
      this.customBottomRightDetail = input();
      this.customBottomLeftDetail = input();
      this.width = input('216px');
      this.height = input('');
    }
    static {
      this.ɵfac = function CustomCardComponent_Factory(t) {
        return new (t || CustomCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CustomCardComponent,
        selectors: [["custom-card"]],
        hostVars: 4,
        hostBindings: function CustomCardComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width())("height", ctx.height());
          }
        },
        inputs: {
          cardBackground: [i0.ɵɵInputFlags.SignalBased, "cardBackground"],
          customTopRightDetail: [i0.ɵɵInputFlags.SignalBased, "customTopRightDetail"],
          customTopLeftDetail: [i0.ɵɵInputFlags.SignalBased, "customTopLeftDetail"],
          customBottomRightDetail: [i0.ɵɵInputFlags.SignalBased, "customBottomRightDetail"],
          customBottomLeftDetail: [i0.ɵɵInputFlags.SignalBased, "customBottomLeftDetail"],
          width: [i0.ɵɵInputFlags.SignalBased, "width"],
          height: [i0.ɵɵInputFlags.SignalBased, "height"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 7,
        vars: 9,
        consts: [[3, "ngStyle"], [1, "d-flex", "flex-row", "justify-content-space-between", "z-index-1"], [3, "ngTemplateOutlet"]],
        template: function CustomCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelementContainer(2, 2)(3, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 1);
            i0.ɵɵelementContainer(5, 2)(6, 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("custom-container p-medium d-flex flex-column justify-content-space-between radius-plus");
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c0, ctx.cardBackground()));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.customTopRightDetail());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.customTopLeftDetail());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.customBottomRightDetail());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.customBottomLeftDetail());
          }
        },
        dependencies: [ApiImageModule, PipesModule, NgStyle, NgTemplateOutlet],
        styles: [".custom-container[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;flex:1 1 auto}.custom-container[_ngcontent-%COMP%]:before{content:\"\";position:absolute;inset:0;background:linear-gradient(294deg,rgba(0,0,0,.35),transparent);-webkit-mix-blend-mode:multiply;mix-blend-mode:multiply;-webkit-backdrop-filter:saturate(1.2);backdrop-filter:saturate(1.2)}.z-index-1[_ngcontent-%COMP%]{z-index:1}@supports (-webkit-backdrop-filter: none){.custom-container[_ngcontent-%COMP%]:before{background-blend-mode:normal;-webkit-backdrop-filter:none;backdrop-filter:none}}"]
      });
    }
  }
  return CustomCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxCard = /*#__PURE__*/(() => {
  class NgxCard {
    constructor() {
      this.cardMode = input.required();
      this.cardSize = input('default');
      this.loading = input(false);
      this.disabled = input(false);
      this.ownerName = input('');
      this.expireDate = input('');
      this.cardNumber = input('');
      this.rightDetail = input();
      this.leftDetail = input();
      this.customTopRightDetail = input();
      this.customTopLeftDetail = input();
      this.customBottomRightDetail = input();
      this.customBottomLeftDetail = input();
      this.amount = input();
      this.pinned = input(false);
      this.width = input('216px');
      this.height = input('');
      this.alias = input(null);
      this.isTyping = input(false);
      this.showOwnerLoading = input(true);
      this.cardLabel = input('');
      this.mainLabel = input('');
      this.cardLogo = input('');
      this.cardBackground = input('#099466');
      this.logoWidth = input(24);
      this.logoHeight = input(24);
      this.amountAlign = input('left');
      this.onClickNewCard = output();
      this.onSearchCardBank = output();
    }
    onNewClick() {
      this.onClickNewCard.emit();
    }
    static {
      this.ɵfac = function NgxCard_Factory(t) {
        return new (t || NgxCard)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxCard,
        selectors: [["ngx-card"]],
        hostVars: 6,
        hostBindings: function NgxCard_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width())("height", ctx.height());
            i0.ɵɵclassProp("small", ctx.cardSize() === "small");
          }
        },
        inputs: {
          cardMode: [i0.ɵɵInputFlags.SignalBased, "cardMode"],
          cardSize: [i0.ɵɵInputFlags.SignalBased, "cardSize"],
          loading: [i0.ɵɵInputFlags.SignalBased, "loading"],
          disabled: [i0.ɵɵInputFlags.SignalBased, "disabled"],
          ownerName: [i0.ɵɵInputFlags.SignalBased, "ownerName"],
          expireDate: [i0.ɵɵInputFlags.SignalBased, "expireDate"],
          cardNumber: [i0.ɵɵInputFlags.SignalBased, "cardNumber"],
          rightDetail: [i0.ɵɵInputFlags.SignalBased, "rightDetail"],
          leftDetail: [i0.ɵɵInputFlags.SignalBased, "leftDetail"],
          customTopRightDetail: [i0.ɵɵInputFlags.SignalBased, "customTopRightDetail"],
          customTopLeftDetail: [i0.ɵɵInputFlags.SignalBased, "customTopLeftDetail"],
          customBottomRightDetail: [i0.ɵɵInputFlags.SignalBased, "customBottomRightDetail"],
          customBottomLeftDetail: [i0.ɵɵInputFlags.SignalBased, "customBottomLeftDetail"],
          amount: [i0.ɵɵInputFlags.SignalBased, "amount"],
          pinned: [i0.ɵɵInputFlags.SignalBased, "pinned"],
          width: [i0.ɵɵInputFlags.SignalBased, "width"],
          height: [i0.ɵɵInputFlags.SignalBased, "height"],
          alias: [i0.ɵɵInputFlags.SignalBased, "alias"],
          isTyping: [i0.ɵɵInputFlags.SignalBased, "isTyping"],
          showOwnerLoading: [i0.ɵɵInputFlags.SignalBased, "showOwnerLoading"],
          cardLabel: [i0.ɵɵInputFlags.SignalBased, "cardLabel"],
          mainLabel: [i0.ɵɵInputFlags.SignalBased, "mainLabel"],
          cardLogo: [i0.ɵɵInputFlags.SignalBased, "cardLogo"],
          cardBackground: [i0.ɵɵInputFlags.SignalBased, "cardBackground"],
          logoWidth: [i0.ɵɵInputFlags.SignalBased, "logoWidth"],
          logoHeight: [i0.ɵɵInputFlags.SignalBased, "logoHeight"],
          amountAlign: [i0.ɵɵInputFlags.SignalBased, "amountAlign"]
        },
        outputs: {
          onClickNewCard: "onClickNewCard",
          onSearchCardBank: "onSearchCardBank"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 7,
        vars: 3,
        consts: [[1, "loading"], [1, "pinned", "d-flex", "justify-content-center", "align-items-center", "radius-giant", 2, "z-index", "1000"], ["iconSize", "16px", "name", "pin-2", "type", "linear", 1, "icon-pin"], [1, "radius-plus", 3, "onClickNewCard", "cardSize", "disabled", "ownerName", "expireDate", "cardNumber", "alias", "isTyping", "showOwnerLoading", "logoWidth", "logoHeight"], [1, "radius-plus", 3, "cardSize", "amount", "leftDetail", "rightDetail", "cardLogo", "cardLabel", "mainLabel", "isBnpl", "logoWidth", "logoHeight", "cardBackground", "amountAlign"], [1, "radius-plus", 3, "amountAlign", "cardBackground", "cardSize", "amount", "leftDetail", "rightDetail", "mainLabel", "cardLogo", "cardLabel", "isBnpl", "logoWidth", "logoHeight"], [1, "radius-plus", 3, "ownerName", "cardSize", "leftDetail", "rightDetail", "amount", "logoWidth", "logoHeight"], [1, "radius-plus", 3, "cardBackground", "customTopRightDetail", "customTopLeftDetail", "customBottomRightDetail", "customBottomLeftDetail", "width", "height"]],
        template: function NgxCard_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NgxCard_Conditional_0_Template, 1, 0, "lib-ngx-skeleton-loading", 0)(1, NgxCard_Conditional_1_Template, 2, 0, "div", 1)(2, NgxCard_Case_2_Template, 1, 10)(3, NgxCard_Case_3_Template, 1, 12)(4, NgxCard_Case_4_Template, 1, 12)(5, NgxCard_Case_5_Template, 1, 7)(6, NgxCard_Case_6_Template, 1, 7);
          }
          if (rf & 2) {
            let tmp_2_0;
            i0.ɵɵconditional(0, ctx.loading() ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.pinned() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(2, (tmp_2_0 = ctx.cardMode()) === "bank" ? 2 : tmp_2_0 === "bnpl" ? 3 : tmp_2_0 === "credit" ? 4 : tmp_2_0 === "wallet" ? 5 : tmp_2_0 === "custom" ? 6 : -1);
          }
        },
        dependencies: [BankCardComponent, WalletCardComponent, CreditCardComponent, NgxIcon, NgxSkeletonLoadingComponent, CustomCardComponent],
        styles: ["[_nghost-%COMP%]{direction:rtl;position:relative;aspect-ratio:1.66/1;display:flex;flex-direction:column}.small[_nghost-%COMP%]{width:100%;aspect-ratio:unset;height:80px}[_nghost-%COMP%] > *[_ngcontent-%COMP%]{flex-grow:1;width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden}.pinned[_ngcontent-%COMP%]{position:absolute;background:var(--surface-glass-high-contrast-invert);-webkit-backdrop-filter:blur(7.5px);backdrop-filter:blur(7.5px);width:22px;height:22px;top:-6px;right:-6px}.icon-pin[_ngcontent-%COMP%]{color:#fff}.loading[_ngcontent-%COMP%]{position:absolute;z-index:999}"]
      });
    }
  }
  return NgxCard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-card
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxCard };
